import { motion } from "framer-motion";
import { Instagram, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="py-16 md:py-24 px-6 md:px-12 bg-graphite-dark border-t border-white/5"
      data-testid="footer"
    >
      <div className="max-w-screen-2xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-16">
          {/* Brand Column */}
          <div className="md:col-span-6">
            <h2 className="font-heading text-4xl md:text-6xl font-bold tracking-tighter uppercase text-white mb-6">
              Elise Redfield
            </h2>
            <p className="font-body text-white/50 text-sm max-w-md leading-relaxed">
              Regenerative Strength & Longevity Coaching for Women 35+. 
              Strategic aging through strength science.
            </p>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-3">
            <h3 className="font-heading text-sm tracking-[0.2em] uppercase text-white/70 mb-6">
              Contact
            </h3>
            <div className="space-y-4">
              <a 
                href="mailto:elise.redfield@gmail.com"
                className="flex items-center gap-3 text-white/50 hover:text-white transition-colors"
              >
                <Mail size={16} strokeWidth={1.5} />
                <span className="font-body text-sm">elise.redfield@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-white/50">
                <MapPin size={16} strokeWidth={1.5} />
                <span className="font-body text-sm">Minnetonka, MN</span>
              </div>
            </div>
          </div>

          {/* Social Column */}
          <div className="md:col-span-3">
            <h3 className="font-heading text-sm tracking-[0.2em] uppercase text-white/70 mb-6">
              Follow
            </h3>
            <a
              href="https://instagram.com/eliseredfield_"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-white/50 hover:text-white transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={20} strokeWidth={1.5} />
              <span className="font-body text-sm">@eliseredfield_</span>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="divider mb-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-white/30">
            © {currentYear} Elise Redfield. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a 
              href="#" 
              className="font-body text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Privacy Policy
            </a>
            <a 
              href="#" 
              className="font-body text-xs text-white/30 hover:text-white/60 transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
